// extracted by mini-css-extract-plugin
module.exports = {"bundle":"bundle_bundle__2t172","trash":"bundle_trash__1l1aL"};